import React, { useCallback } from 'react';
import { Button, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import { useTranslation } from 'react-i18next';
import { ModalTitle } from 'components/index';

import styles from './RemoveDialog.module.scss';

export interface RemoveDialogProps extends DialogProps {
  userName: string;
  onConfirm: () => void;
  onClose?: () => void;
}

export function RemoveDialog({ onConfirm, userName, onClose, ...rest }: RemoveDialogProps) {
  const { t } = useTranslation('providerRoom');
  const onCopyToClipboard = useCallback(() => {
    onConfirm();
  }, []);

  return (
    <Dialog {...rest} className={styles.dialog}>
      <DialogTitle>
        <ModalTitle title={t('remove')} onClose={onClose} />
      </DialogTitle>
      <DialogContent>
        <Typography component='p' variant='body5'>
          {t('remove')}
          <Typography component='span' variant='body5' fontWeight={700}>
            &nbsp;{userName}&nbsp;
          </Typography>
          {t('fromQueueQuestion')}
        </Typography>

        <Stack direction='row' alignItems='center' className={styles.actions}>
          <Button variant='outlined' fullWidth className={styles.formButton} onClick={onClose}>
            {t('cancel')}
          </Button>
          <Button variant='contained' fullWidth className={styles.formButton} onClick={onCopyToClipboard}>
            {t('remove')}
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
